import { useCallback, useMemo } from "react";
import { useAuth0 } from "componentes/Auth0/useAuth";
import { ETipoUsuario, normalizeTipoUsuario } from "domain/types";
import { ECapacidad, can } from "domain/capacidades";

interface AuthStateShape {
  readonly user?: { readonly userType?: unknown } | null;
}

export interface UsePerfilResult {
  readonly tipoUsuario: ETipoUsuario | undefined;
  readonly isClienteFinal: boolean;
  readonly isAgenciero: boolean;
  readonly isInterno: boolean;
  readonly isProductor: boolean;
  readonly isGestor: boolean;
  readonly isVendedor: boolean;
  readonly isSupervisor: boolean;
  readonly can: (capacidad: ECapacidad) => boolean;
}

export function usePerfil(): UsePerfilResult {
  const { authState } = useAuth0() as { authState?: AuthStateShape | null };

  const tipoUsuario = normalizeTipoUsuario(authState?.user?.userType);

  const canDelPerfil = useCallback(
    (capacidad: ECapacidad) =>
      tipoUsuario ? can(tipoUsuario, capacidad) : false,
    [tipoUsuario],
  );

  return useMemo(
    () => ({
      tipoUsuario,
      isClienteFinal: tipoUsuario === ETipoUsuario.ClienteFinal,
      isAgenciero: tipoUsuario === ETipoUsuario.Agenciero,
      isInterno: tipoUsuario === ETipoUsuario.Interno,
      isProductor: tipoUsuario === ETipoUsuario.Productor,
      isGestor: tipoUsuario === ETipoUsuario.Gestor,
      isVendedor: tipoUsuario === ETipoUsuario.Vendedor,
      isSupervisor: tipoUsuario === ETipoUsuario.Supervisor,
      can: canDelPerfil,
    }),
    [tipoUsuario, canDelPerfil],
  );
}

export default usePerfil;
